import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import UIUploadDrawer from './UI.UploadDrawer';
import { Button, Modal, Drawer, Select, Dropdown, Menu } from 'antd';
// import { Link } from 'react-router-dom';
const { Option } = Select;

const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {

}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }

    render() {
        const companyInfo = this.modulesState.companyInfo;
        const menu = (
            <Menu className={css.menu2} >
                <Menu.Item>
                    <a onClick={this.goRegister}>注册</a>
                </Menu.Item>
            </Menu>
        );
        return (
            <div className={css.modules}>
                <header className={css.companyHeader}>
                    <img className={css.companyHeaderLogo} src={require('./img/header-logo.png')} style={{ height: "24px" }} />
                    <Dropdown placement="bottomCenter" overlay={menu} >
                        <img height="20" src={require('./img/img.headPortrait.svg')} className={css.companyHeaderRegister}/>
                    </Dropdown>
                </header>
                {
                    companyInfo.mainImageUrl ?
                        <div className={css.IndexBg}>
                            <img src={companyInfo.mainImageUrl} style={{ width: "100%" }} />
                        </div> :
                        <div className={css.IndexBgDefault}>
                            <div className={css.tipsDefault}>
                                <img src={require('./img/logoDefault.png')} style={{ width: "66px" }} />
                                <p>请前往信息页，上传公司风采用于封面展示。</p>
                            </div>
                        </div>
                }
                <div className={css.companyContent}>
                    <div className={css.companyBasInfo}>
                        <span className={css.companyLogo}>
                            {
                                companyInfo.logoImageUrl ?
                                    <img className={css.companyHeaderLogo} src={companyInfo.logoImageUrl} style={{ height: "157px" }} />
                                    :
                                    <span className={css.defaultLogo}>LOGO</span>
                            }
                        </span>
                        <div className={css.companyBasInfoList}>
                            <div className={css.companyContactInfo}>
                                <span className={css.companyName}>{companyInfo.companyName}</span>
                                {/* <span className={css.companyWeb}>xunliancloud.com</span> */}
                                <Button className={css.companyBt} onClick={() => ModulesAction.onCloseDrawer(true)}>交付发票</Button>
                            </div>
                            {
                                (companyInfo.contactName || companyInfo.contactEmail || companyInfo.contactPhone || companyInfo.companyTaxNo) &&
                                <div className={css.companyAddress}>
                                    <div className={css.addressItem} style={{ width: '25%' }}>
                                        <span className={css.addressName}>联系人</span>
                                        <p className={css.addressVal}>{companyInfo.contactName}</p>
                                    </div>
                                    <div className={css.addressItem} style={{ width: '25%' }}>
                                        <span className={css.addressName}>联系邮箱</span>
                                        <p className={css.addressVal}>{companyInfo.contactEmail}</p>
                                    </div>
                                    <div className={css.addressItem} style={{ width: '25%' }}>
                                        <span className={css.addressName}>联系电话</span>
                                        <p className={css.addressVal}>{companyInfo.contactPhone}</p>
                                    </div>
                                    <div className={css.addressItem} style={{ width: '25%' }}>
                                        <span className={css.addressName}>纳税人识别号</span>
                                        <p className={css.addressVal}>{companyInfo.companyTaxNo}</p>
                                    </div>
                                </div>
                            }
                            <div className={css.companyAddress}>
                                <div className={css.addressItem} style={{ width: '25%' }}>
                                    <span className={css.addressName}>国家或地区</span>
                                    <p className={css.addressVal}>{companyInfo.country}</p>
                                </div>
                                <div className={css.addressItem} style={{ width: '25%' }}>
                                    <span className={css.addressName}>所在城市</span>
                                    <p className={css.addressVal}>{companyInfo.state + companyInfo.city}</p>
                                </div>
                                <div className={css.addressItem} style={{ width: '50%' }}>
                                    <span className={css.addressName}>详细地址</span>
                                    <p className={css.addressVal}>{companyInfo.address}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={css.companyAbout}>
                        <div className={css.aboutTitle}>About us</div>
                        <div className={css.aboutContent}>
                            {companyInfo.description}
                        </div>
                        {/* <div className={css.aboutTagList}>
                            <span className={css.aboutTag}>科技</span>
                            <span className={css.aboutTag}>协同</span>
                            <span className={css.aboutTag}>创新</span>
                            <span className={css.aboutTag}>产业互联</span>
                        </div> */}
                    </div>
                    {
                        this.getCompanyDisplay()
                    }
                </div>
                {/* 风采图展示 */}
                <Modal visible={this.modulesState.showEleganceModal} footer={null} className={css.imgModal} onCancel={() => ModulesAction.showEleganceModal(false)}>
                    <img alt="" style={{ width: '100%' }} src={this.modulesState.imgUrlElegance} />
                </Modal>
                {/* 上传 */}
                <Drawer
                    title="上传交付"
                    width={420}
                    destroyOnClose={true}
                    onClose={() => ModulesAction.onCloseDrawer(false)}
                    visible={this.modulesState.visibleDrawer}
                    bodyStyle={{padding: 20,overflow: 'auto',height: 'calc(100% - 120px)' }}
                >
                    <UIUploadDrawer />
                </Drawer>
            </div>
        );
    }
    // 去登录页面
    private goRegister = () => {
        const url = kts.Env.instance().workingUrl('//login{env}kingxunlian.com') + '/userRegister.html';
        window.parent.open(url, '_self');
    }
    /**
     * 选择切换上传/ 邮箱提示
     */
    private drawerSelectChange = (e) => {
        this.modulesState.drawerSelect = e;
        this.setModulesState();
    }
    /**
     * 获取公司风采图
     */
    private getCompanyDisplay = () => {
        const imageUrls = this.modulesState.companyInfo.imageUrls || [];
        
        if (!imageUrls.length) {
            return null;
        }

        let listImg = imageUrls.map(item => {
            return (<img
                key={item}
                onClick={() => ModulesAction.showEleganceModal(true, item)}
                src={item}
                style={{ width: "392px", height: "229px" }}
            />);
        });
        return (
            <div className={css.companyDisplay}>
                <div className={css.displayTitle}>Display</div>
                <div className={css.displayList}>
                    {listImg}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/display/modules/Home/CompanyPublic/UI.Components.tsx